import { render, staticRenderFns } from "./manageGy.vue?vue&type=template&id=94d5c890&"
import script from "./manageGy.vue?vue&type=script&lang=js&"
export * from "./manageGy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports